module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="phx-referentiel-wrap input-group">\r\n    <input class="phx-referentiel-input" type="text" placeholder="'+
((__t=(placeholder))==null?'':__t)+
'"/>\r\n    <div class="input-group-append">\r\n      <span class="cw-referentiel-button input-group-text">'+
((__t=(UTILS.getSVGIcon('loupe')))==null?'':__t)+
'</span>\r\n    </div>\r\n  </div>\r\n<div class="phx-referentiel-selection"></div>\r\n';
}
return __p;
};
